import { render, staticRenderFns } from "./QuestionnairesAsthma.vue?vue&type=template&id=67b8b132&lang=pug&"
import script from "./QuestionnairesAsthma.vue?vue&type=script&lang=js&"
export * from "./QuestionnairesAsthma.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnairesAsthma.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports